import 'rxjs/add/operator/do';
import 'rxjs/add/operator/filter';
import {STATE_CHANGE_SUCCESS} from 'redux-ui-router/lib/action-types';

export const epics = [
  onLocationChange,
];

onLocationChange.$inject = [
  'modalManager',
];

/**
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @param dependencies
 * @return {Observable<ReduxAction>}
 */
export function onLocationChange(action$, store, dependencies) {
  return action$.ofType(STATE_CHANGE_SUCCESS)
    .do(() => dependencies.modalManager.closeAllOnNav())
    .filter(() => false);
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/react-modals/navigationEpic.js